import { queryOptions } from '@tanstack/react-query';
import TicketService from '../ticket/ticket.service';
import { useCallback } from 'react';
import { CustomField } from '@/interfaces/schemas/customField.schema';

// Query Key Factory
export const customFields = {
  all: ['customFieldsAdmin'] as const,
  // types: (customerId?: number) => [...customFields.all, 'types', customerId] as const,
  // statuses: (customerId?: number) => [...customFields.all, 'statuses', customerId] as const
};

export const createCustomFieldsQueryOptions = () => {
  const ticketService = TicketService();
  return queryOptions({
    queryKey: customFields.all,
    queryFn: async () => {
      const response = await ticketService.getTicketCustomFieldGroupsById({});
      return response.data;
    },
    select: useCallback((data: CustomField[]) => {
      if (!data) return [];

      // sort the data by name
      data.sort((a, b) => a.name.localeCompare(b.name));

      return data.map((field: CustomField) => ({
        ...field,
        customerIdList: field.customerIdList?.split('|').map(Number) ?? [],
        customerList: field.customerList?.split('|') ?? []
      }));
    }, []),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 5,
  });
};